/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipo di errore di notifica del servizio mensa.
 */
export enum ServizioMensaReportType {

    SEND_MAIL_ERROR = 'SEND_MAIL_ERROR',

    SEND_SMS_ERROR = 'SEND_SMS_ERROR'
}

